import i18next from 'i18next';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchOwnPatients } from '@/api/patients/patientsApi';
import type { OwnerPet } from '@/api/patients/patientsApi.types';

export function useOwnPatientsQuery(isEnabled: boolean): UseQueryResult<OwnerPet[], Error> {
  return useQuery({
    queryKey: ['ownPatients', i18next.language],
    queryFn: fetchOwnPatients,
    enabled: isEnabled,
  });
}
